import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const base_url = process.env.BASE_URL;

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: '/publications'
    },
    {
        path: '/login',
        name: 'Login',
        components: {
            default: () => import('../views/Login.vue'),
        },
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/publications',
        name: 'Publications',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Publications.vue'),
        },
        meta: {
            title: 'Publications',
            requiresAuth: true
        }
    },
    {
        path: '/publications/:publication_id',
        name: 'Publication',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Publication.vue'),
        },
        props: {
            default: true
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/trunks',
        name: 'Trunks',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Trunks.vue'),
        },
        meta: {
            title: 'Trunks',
            requiresAuth: true
        }
    },
    {
        path: '/trunks/:publication_id',
        name: 'Trunk',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Trunks.vue'),
        },
        props: {
            default: true
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/publications/:publication_id/units/:unit_id/crossword/blank_preview',
        name: 'PreviewBlankCrossword',
        components: {
            default: () => import('@/components/unit/CrosswordPreview.vue')
        },
        props: {
            default: true
        },
        meta: {
            title: 'Preview Blank Crossword',
            requiresAuth: false
        }
    },
    {
        path: '/publications/:publication_id/units/:unit_id/crossword/filled_preview',
        name: 'PreviewFilledCrossword',
        components: {
            default: () => import('@/components/unit/CrosswordPreview.vue')
        },
        props: {
            default: true
        },
        meta: {
            title: 'Preview Filled Crossword',
            requiresAuth: false
        }
    },
    {
        path: '/articles',
        name: 'Articles',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Articles.vue'),
        },
        meta: {
            title: 'Articles',
            requiresAuth: true
        }
    },
    {
        path: '/standards',
        name: 'Standards',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Standards.vue'),
        },
        meta: {
            title: 'Standards',
            requiresAuth: true
        }
    },
    {
        path: '/media',
        name: 'Media',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Media.vue'),
        },
        meta: {
            title: 'Media',
            requiresAuth: true
        }
    },
    {
        path: '/printables',
        name: 'Printables',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Printables.vue'),
        },
        meta: {
            title: 'Printables',
            requiresAuth: true
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Reports.vue'),
        },
        meta: {
            title: 'Reports',
            requiresAuth: true
        }
    },
    {
        path: '/weeks',
        name: 'Weeks',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Weeks.vue'),
        },
        meta: {
            title: 'Weeks',
            requiresAuth: true
        }
    },
    {
        path: '/questionList/:question_type/:id',
        name: 'Question List',
        components: {
            default: () => import('../views/QuestionList.vue'),
        },
        meta: {
            title: 'Question List',
            requiresAuth: true
        }
    },
    {
        path: '/admin',
        name: 'Admin',
        components: {
            navbar: () => import('@/components/Navbar.vue'),
            default: () => import('../views/Admin.vue'),
        },
        meta: {
            title: 'Admin',
            requiresAuth: true
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkExactActiveClass: 'active exact-active',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

export default router
